import callAPiBase from './base';

const usersApi = {
  list: ({
    Room,
    Limit,
    UpdatedAt,
    ConversationStatus,
  }: {
    Room: string;
    Limit: string;
    UpdatedAt: string;
    ConversationStatus: number;
  }) =>
    callAPiBase({
      endpoint: `/api/users?limit=${Limit}&room=${Room}&updatedAt=${UpdatedAt}&conversationStatus=${ConversationStatus}`,
      method: 'GET',
      useToken: true,
    }),
  update: ({
    Room,
    attendantId,
    username,
    conversationStatus,
  }: {
    Room: string;
    attendantId: string;
    username: string;
    conversationStatus: number;
  }) =>
    callAPiBase({
      endpoint: `/api/users/conversation?Room=${Room}&attendantOwnerID=${attendantId}&username=${username}&conversationStatus=${conversationStatus}`,
      method: 'PUT',
      useToken: true,
    }),
};

export { usersApi };
export default usersApi;
